import { render, staticRenderFns } from "./NomenclatureEdit.vue?vue&type=template&id=f63f12ce"
import script from "./NomenclatureEdit.vue?vue&type=script&lang=ts"
export * from "./NomenclatureEdit.vue?vue&type=script&lang=ts"
import style0 from "./NomenclatureEdit.vue?vue&type=style&index=0&id=f63f12ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports